import React from "react";
import { Colors } from "../../constants/Colors";
import { TextWrapper } from "../../constants/common/StyledGlobalConstants";
import styled from "styled-components";
import { BILLINGPAYMENTS_REDBANNER_CONSTANTS } from "../../constants/StringConstants";
import PropTypes from "prop-types";

const ParentContainer = styled.div`
  padding: 8px 24px;
  display: flex;
  flex-direction: row;
  border: 1px solid;
  border-color: ${Colors.dimGray};
  border-radius: 4px;
  width: 100%;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const ChildContainer = styled.div`
  text-align: left;
  flex: 1 1 25%;
  padding: 10px;

  @media (max-width: 480px) {
    flex: 1 1 100%;
  }
`;

const DetailHeading = styled(TextWrapper)`
  margin-bottom: 4px;
  font-size: 0.875rem;
  color: ${Colors.dimGray};
`;

const Detail = styled(TextWrapper)`
  font-size: 0.875rem;
`;

const BankDetails = ({ regionId, t, bankDetails }) => {
  const isUKCountry = regionId === "826";

  const renderDetail = (heading, detail, isFullWidth = false) => (
    <ChildContainer style={{ flex: isFullWidth ? "1 1 100%" : "1 1 25%" }}>
      <DetailHeading>{heading}</DetailHeading>
      <Detail>{detail}</Detail>
    </ChildContainer>
  );

  return (
    <ParentContainer>
      {renderDetail(t(BILLINGPAYMENTS_REDBANNER_CONSTANTS.ACCOUNT_HOLDER), t(bankDetails?.accHolder), isUKCountry)}
      {isUKCountry ? (
        <>
          {renderDetail(t(BILLINGPAYMENTS_REDBANNER_CONSTANTS.SWIFTBIC), t(bankDetails?.swiftbic))}
          {renderDetail(t(BILLINGPAYMENTS_REDBANNER_CONSTANTS.SORT_CODE), t(bankDetails?.sortCode))}
          {renderDetail(t(BILLINGPAYMENTS_REDBANNER_CONSTANTS.ACCOUNT_NUMBER), t(bankDetails?.accNumber))}
        </>
      ) : (
        <>
          {renderDetail(t(BILLINGPAYMENTS_REDBANNER_CONSTANTS.IBAN), t(bankDetails?.iban))}
          {renderDetail(t(BILLINGPAYMENTS_REDBANNER_CONSTANTS.SWIFTBIC), t(bankDetails?.swiftbic))}
        </>
      )}
    </ParentContainer>
  );
};

BankDetails.propTypes = {
  regionId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  bankDetails: PropTypes.object
};

export default BankDetails;

